import React from 'react';
import {
  Box, Button, Typography,
} from '@mui/material';
import { Trans } from '@gamiphy/react-i18n';
import { observer } from 'mobx-react';
import { UserStore } from '@gamiphy/loyalty-station-desktop/store/user';
import { useMobile } from '@gamiphy/loyalty-station-desktop/utils/mobile';

const ConfirmPhone: React.FC<{
  onDone: (phone: string) => void,
  unverifiedPhone: string,
  onEdit: () => void,
  buttonsDirection?: 'column' | 'row'
}> = ({
  unverifiedPhone,
  onDone,
  onEdit,
  buttonsDirection,
}) => {
  const [verifiying, setVerifiying] = React.useState(false);
  const isMobile = useMobile();

  const onVerify = React.useCallback(async () => {
    setVerifiying(true);
    await UserStore.updatePhone(unverifiedPhone);
    onDone(unverifiedPhone);
  }, [unverifiedPhone]);

  return (
    <>
      <Box width="100%" border="1px solid #EAEBF0" borderRadius="12px" p={1}>
        <Typography textAlign="center" fontSize={24} fontWeight={500}>
          {`${unverifiedPhone.slice(0, 10)}***${unverifiedPhone.slice(-1)}`}
        </Typography>
      </Box>
      <Box display="flex" gap={1} flexDirection={isMobile ? 'column' : (buttonsDirection ?? 'row')} width="100%" mt={1}>
        <Button
          variant="outlined"
          fullWidth
          onClick={onEdit}
          color="inherit"
          sx={{
            fontSize: 16,
            borderColor: '#D0D5DD',
          }}
        >
          <Trans
            i18nKey="cashbackPopup.number.edit"
            defaults="Edit my number"
          />
        </Button>
        <Button
          variant="contained"
          fullWidth
          onClick={onVerify}
          disabled={verifiying}
          sx={{
            fontSize: 16,
          }}
        >
          <Trans
            i18nKey="shared.verify"
            defaults="Verify"
          />
        </Button>
      </Box>
    </>
  );
};

export default observer(ConfirmPhone);
